import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AddPeepOmnifield as AddPeepOmnifieldMutation,
    AddPeepOmnifieldVariables,
    OmnifieldAddInput,
} from 'nutshell-graphql-types';

import ADD_PEEP_OMNIFIELD from '../mutations/add-peep-omnifield.graphql';

export const useAddPeepOmnifield = (): {
    addPeepOmnifield: (input: OmnifieldAddInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [addPeepOmnifield, {loading, error}] = useMutation<
        AddPeepOmnifieldMutation,
        AddPeepOmnifieldVariables
    >(ADD_PEEP_OMNIFIELD);

    return {
        addPeepOmnifield: (input: OmnifieldAddInput) => addPeepOmnifield({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
